module.exports = __webpack_public_path__ + "static/media/bg.3bf74d0c.png";